const activityListeners = new Set<() => void>();
const requestStartListeners = new Set<() => void>();
const readStartListeners = new Set<() => void>();

export function registerFileBrowserActivityListener(listener: () => void): () => void {
  activityListeners.add(listener);
  return () => {
    activityListeners.delete(listener);
  };
}

export function registerFileBrowserRequestStartListener(listener: () => void): () => void {
  requestStartListeners.add(listener);
  return () => {
    requestStartListeners.delete(listener);
  };
}

export function registerFileBrowserReadStartListener(listener: () => void): () => void {
  readStartListeners.add(listener);
  return () => {
    readStartListeners.delete(listener);
  };
}

export function notifyFileBrowserActivity(): void {
  for (const listener of activityListeners) listener();
}

export function notifyFileBrowserRequestStart(): void {
  for (const listener of requestStartListeners) listener();
}

export function notifyFileBrowserReadStart(): void {
  for (const listener of readStartListeners) listener();
}
